<template>
    <div class="ga_content_wrap" style="background-color: #f5f5f5">
        <!-- 그리드 영역 확인용 배경색-->
        <iframe
            width="1300"
            height="650"
            src="https://lookerstudio.google.com/embed/reporting/082fce22-0bdb-4606-9fa2-fcfa0daeba53/page/p_kid0py8pwd"
            frameborder="0"
            style="border: 0"
            allowfullscreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
    </div>
</template>
